import React from "react";
import { motion } from "framer-motion";

// Class component that renders only on client-side
class NoSSRMotion extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isClient: false,
		};
	}

	componentDidMount() {
		this.setState({ isClient: true });
	}

	render() {
		const { children, tag = "div", ...rest } = this.props;

		// On server, render a simple div with the same children
		if (!this.state.isClient) {
			return <div>{children}</div>;
		}

		// On client, render the actual motion component
		const MotionTag = motion[tag];
		return <MotionTag {...rest}>{children}</MotionTag>;
	}
}

export default NoSSRMotion;
